import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AuthService } from './../services/auth.service';
import { Router } from '@angular/router';
import { EncrDecrService } from './../services/encr-decr.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  account_inactive: boolean = false;
  incorrect_email_pwd: boolean = false;
  err_message: string;

  public user_id: any = '';
  public company_id: any = '';
  public APIKEY: any = '';

  loginUserData = {
    email: '',
    password: '',
    APIKEY: 'SOAV2@123',
    mode: 'log_in',
  };


  constructor(
    private _auth: AuthService,
    private _router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private EncrDecr: EncrDecrService,
    //private _app : AppComponent
  ) {
  }

  loginform: any;
  recoverform: any;

  ngOnInit() {

    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    const logOutData = {
      user_id: this.user_id,
      company_id: this.company_id,
      APIKEY: this.APIKEY,
      mode: 'log_out',
    };

    this._auth.logout(logOutData);
    this.loginform = true;
    this.recoverform = false;
  }

  toRecover() {
    this.loginform = false;
    this.recoverform = true;
  }

  tologin() {
    this.loginform = true;
    this.recoverform = false;
  }

  loginUser() {
    ///this.spinnerService.show();
    var encrypted_id = this.EncrDecr.set(localStorage.getItem('key'), this.loginUserData.password);
    // console.log(encrypted_id);
    this.loginUserData.password = encrypted_id;
    this._auth.loginUser(this.loginUserData)
      .subscribe(
        res => {
          //console.log(res); 
          if (res.status == true) {
            // this.spinnerService.hide();
            localStorage.setItem('currentUser', JSON.stringify(res));
            localStorage.setItem("id", res.id);
            localStorage.setItem("company_id", res.company_id);
            localStorage.setItem("role_id", res.role_id);
            localStorage.setItem("role_name", res.role_name);
            localStorage.setItem("APIKEY", 'SOAV2@123');
            if (localStorage.getItem("role_name") == "SuperAdmin") {
              localStorage.setItem("roletype", "superAdmin");
            }
            if (res.role_name != 'Professional User') {

              if (res.role_id == 1 || res.role_id == 2) {
                this._router.navigate(["/super-admin/customer-list/active"]);
              }
              else if (res.role_id == 3) {
                this._router.navigate(["/customer/customerSOA-list"]);
              }
              else if (res.role_id == 431) {
                this._router.navigate(["/super-admin/customer-list/active"]);

              }
              else {
                //this._router.navigate(["/customer/customer-list/active"]);
                //link chanaged by deepak on 14Feb2022
                this._router.navigate(["/mobile/mobile-list"]);
              }
            }
            else {
              this._router.navigate(["/mobile/mobile-list"]);
            }


          }
          if (res.message != '' && res.status == false) {
            alert(res.message);
          }
          // else {
          // }
        },
        err => {
          //this.isloginerror=true;
          this.err_message = err.error.message;

          if (err.error.message == "Email address & password doesn't matched.") {
            this.incorrect_email_pwd = true;
            this.account_inactive = false;
          }

          if (err.error.message == "Your account is Inactive") {
            this.incorrect_email_pwd = false;
            this.account_inactive = true;
          }

        },
      );

  }

}
